import { PropsWithChildren } from 'react';
import styles from './ColumnGrid.module.scss';

/* ColumnGrid */
export default function ColumnGrid({ children, ...props }: PropsWithChildren) {
  return (
    <div className={styles.columnGrid} {...props}>
      {children}
    </div>
  );
}
/* */
